import {SelectInput, ReferenceInput} from 'react-admin';
import React from "react";

const IvaCombo = (props) => {
    const isReadonly = props.readOnly;
    return (
        <ReferenceInput label="Iva" source="id_iva" reference="iva" variant="outlined" initialValue={1}>
            <SelectInput optionText="d_iva" InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: isReadonly}}/>
        </ReferenceInput>
    )
};

export default IvaCombo;
